/** URL-addressable Admin views; UI-only navigation, not role authorization. */
export const ADMIN_VIEWS = [
  "overview",
  "events",
  "studios",
  "event-types",
  "partners",
  "partner-directory",
  "moderation",
  "retention",
  "subscriptions",
];

export function getAdminViewFromUrl(location = globalThis.location) {
  if (!location) return "overview";
  const url = new URL(
    location.href ||
      `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`,
    "http://localhost",
  );
  const queryView = url.searchParams.get("view");
  if (ADMIN_VIEWS.includes(queryView)) return queryView;
  const hashView = url.hash.replace(/^#/, "");
  return ADMIN_VIEWS.includes(hashView) ? hashView : "overview";
}

export function navigateAdminView(
  view,
  history = globalThis.history,
  location = globalThis.location,
) {
  if (!ADMIN_VIEWS.includes(view) || !history || !location) return false;
  if (getAdminViewFromUrl(location) === view) return true;
  const url = new URL(location.href, "http://localhost");
  url.searchParams.set("view", view);
  history.pushState(
    { ...(history.state || {}), view },
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
  return true;
}
